import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@material-ui/core'

import { X as CloseIcon } from 'react-feather'
import { Select } from 'components'
import { routes } from 'Routes'

import useStyles from './styles'
import constants from 'constants/index'

const SelectCompanyType = ({ open, onClose }) => {
  const history = useHistory()

  const classes = useStyles()
  const [selectItem, setSelectItem] = useState('')

  const handleChange = (e) => {
    const item = e.target.value
    setSelectItem(item)
  }

  const handleClose = () => {
    setSelectItem('')
    onClose()
  }

  const moveForwardCreateCompany = (type) =>
    history.push(routes.companies.new, { type })

  return (
    <Dialog open={open} fullWidth onClose={handleClose}>
      <Box className={classes.boxTitle}>
        <DialogTitle>
          <Typography variant="h5">Selecione o tipo de empresa</Typography>
        </DialogTitle>
        <CloseIcon
          size={24}
          className={classes.closeIcon}
          onClick={handleClose}
        />
      </Box>
      <Divider />
      <DialogContent>
        <Typography className={classes.atention}>
          Atenção: Empresas reais e trial (gratuidade) devem ser criadas na tela
          de clientes presente no modulo de vendas.
        </Typography>

        <Box my={2}>
          <Select
            items={constants.companies.SELECT_TYPE_COMPANIES_CREATE}
            onChange={handleChange}
            label="Selecione o tipo de empresa"
          />
          {selectItem && (
            <Box className={classes.dialogActions}>
              <Button
                type="button"
                color="primary"
                variant="contained"
                onClick={() => moveForwardCreateCompany(selectItem)}
              >
                AVANÇAR
              </Button>
            </Box>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  )
}

SelectCompanyType.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default SelectCompanyType
